import { LocalStorageFeatureFlags } from '@backstage/core-app-api';

import { useFeatureFlag } from '@spotify/confidence-core-react';

export class ConfidenceFeatureFlags extends LocalStorageFeatureFlags {
  isActive(name: string): boolean {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isFlagEnabled = useFeatureFlag(`${name}.enabled`, false);
    return super.isActive(name) || isFlagEnabled;
  }
}
